/**
 * Offset-based pager. Not fancy — just prev/next with a running
 * page number. The service tells us `has_more`; we derive prev
 * from the local offset. Shared so every list endpoint uses the
 * same pattern.
 */

export default function Pagination(props: {
  offset: number;
  limit: number;
  hasMore: boolean;
  onOffset: (next: number) => void;
}) {
  const page = () => Math.floor(props.offset / props.limit) + 1;
  const prevDisabled = () => props.offset === 0;
  const nextDisabled = () => !props.hasMore;

  return (
    <div class="flex items-center justify-between pt-3 text-sm">
      <div class="text-slate-500">Page {page()}</div>
      <div class="flex gap-2">
        <button
          class="btn-secondary"
          disabled={prevDisabled()}
          onClick={() =>
            props.onOffset(Math.max(0, props.offset - props.limit))
          }
        >
          Previous
        </button>
        <button
          class="btn-secondary"
          disabled={nextDisabled()}
          onClick={() => props.onOffset(props.offset + props.limit)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
